// Components
import React from 'react';
import mapValues from 'lodash/mapValues';
import { Map } from 'immutable';
import { EditorBlock } from 'draft-js';

import Atomic from './Atomic';
import HorizontalRule from './HorizontalRule';
import Code from './Code';
import Callout from './Callout';
import { getHeaderId } from '../utilities/tableOfContents';

import { BLOCK_TYPE, ENTITY_TYPE, HEADER_TAGS } from '../utilities/CONSTANTS';

const Header = (props) => {
    const { block } = props;
    const Tag = HEADER_TAGS[block.getType()] || 'span';
    const key = block.getKey();
    const text = block.getText();
    const id = getHeaderId(key, text);

    return (
        <Tag id={id}>
            <EditorBlock {...props} />
        </Tag>
    );
};

const blockRenderMap = Map({
    'header-one': Header,
    'header-two': Header,
    'header-three': Header,
});

const blockRenderer = (block, contentState, tableMethods, nestedEditorProps, editorState, setEditorState, selectImage, readOnly, getEditorState, isNestedEditor) => {
    let component;
    let editable;
    let props = {};

    const blockType = block.getType();
    const entityKey = block.getEntityAt(0);

    if (blockRenderMap.get(blockType)) {
        component = blockRenderMap.get(blockType);
    } else if (blockType === BLOCK_TYPE.ATOMIC) {
        const entity = entityKey != null ? contentState.getEntity(entityKey) : null;
        const type = entity != null ? entity.getType().toUpperCase() : null;
        const blockKey = block.getKey();
        if (type === ENTITY_TYPE.EMBEDLY) {
            component = Atomic;
            editable = false;
            props = {
                isNestedEditor,
                setEditorState,
                nestedEditorProps,
                editorState,
            };
        } else {
            tableMethods = mapValues(tableMethods, fn => (...args) => fn(blockKey, ...args));
            component = Atomic;
            props = {
                tableMethods,
                nestedEditorProps,
                editorState,
                selectImage,
                setEditorState,
                isNestedEditor,
                getEditorState,
                tableKey: blockKey,
            };
            editable = false;
        }
    } else if (blockType === BLOCK_TYPE.HR) { // this is left over from pages that have old hr issue #350
        component = HorizontalRule;
        editable = false;
        props = {
            setEditorState,
            nestedEditorProps,
            editorState,
        };
    } else if (blockType === BLOCK_TYPE.CALLOUT) {
        component = Callout;
        props = {
            setEditorState,
            readOnly,
            editorState,
            color: block.data.get('color'),
        };
    } else if (blockType === BLOCK_TYPE.CODE) {
        component = Code;
        props = {
            setEditorState,
            readOnly,
            editorState,
            language: block.data.get('language'),
        };
    }

    return component ? { props, component, editable } : null;
};

export default blockRenderer;
